module.exports = __webpack_public_path__ + "img/img-25.fe1bc66b.svg";